const firebaseConfig = {
    apiKey: "AIzaSyD2kCfQ5KCwFEMK1nKQyCHWPaf_cByjHJo",
    authDomain: "rickandmorty-e2bbe.firebaseapp.com",
    projectId: "rickandmorty-e2bbe",
    storageBucket: "rickandmorty-e2bbe.appspot.com",
    messagingSenderId: "528734189845",
    appId: "1:528734189845:web:ec5d63200ae2da3c89d11c",
    measurementId: "G-8NZ0WGJ2P1"
};
export default firebaseConfig;